export default "/_next/static/images/featured-bg-membership-552cc55a514e03f5ef085f087a981c33.jpg";